import React from 'react';
import { Spin, Empty } from 'antd';
import ReactEcharts from 'echarts-for-react';
import { DevicePoint, RawData } from '../../../../api/history';
import { DatePickerType, StatisticsPartition } from '../DateSwitch';
import { chartOption, scatterChartOption } from './chartOption';
import { isNil } from 'lodash-es';

export interface HistoryChartProps {
  loading?: boolean;
  data?: RawData[];
  mode: DatePickerType;
  activePoint?: DevicePoint;
  dateMode?: StatisticsPartition;
}

const HistoryChart = (props: HistoryChartProps) => {
  const { loading, data, activePoint, mode, dateMode } = props;

  const filterData = data?.filter(item => !isNil(item.value));

  if (!loading && filterData?.length === 0) {
    return (
      <div style={{ marginTop: 40 }}>
        <Empty />
      </div>
    );
  }

  return (
    <Spin spinning={loading}>
      {filterData && filterData.length > 0 && (
        <ReactEcharts
          option={chartOption(data, mode, activePoint, dateMode)}
          style={{ height: 400 }}
          notMerge
          lazyUpdate={false}
        />
      )}
    </Spin>
  );
};

export interface HistoryOriginalChartProps {
  loading?: boolean;
  data?: RawData[];
  activePoint?: DevicePoint;
}

export const HistoryOriginalChart = (props: HistoryOriginalChartProps) => {
  const { loading, data, activePoint } = props;

  const filterData = data?.filter(item => !isNil(item.value));

  if (!loading && filterData?.length === 0) {
    return (
      <div style={{ marginTop: 40 }}>
        <Empty />
      </div>
    );
  }

  return (
    <Spin spinning={loading}>
      {filterData && filterData.length > 0 && (
        <ReactEcharts
          option={scatterChartOption(data, activePoint)}
          style={{ height: 400 }}
          notMerge
          lazyUpdate={false}
        />
      )}
    </Spin>
  );
};

export default HistoryChart;
